const DAY_NAMES = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
export const MONTH_NAMES = [
  "Janvier",
  "Fevrier",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Aout",
  "Septembre",
  "Octobre",
  "Novembre",
  "Decembre",
];

export function toDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function getToday(): string {
  return toDateString(new Date());
}

export function getDayName(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  return DAY_NAMES[date.getDay()];
}

export function getDayNumber(dateStr: string): number {
  return new Date(dateStr + "T00:00:00").getDate();
}

export function getMonthYear(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  return `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`;
}

export function getWeekDays(referenceDate: string): string[] {
  const date = new Date(referenceDate + "T00:00:00");
  const dayOfWeek = date.getDay();
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const monday = new Date(date);
  monday.setDate(date.getDate() + mondayOffset);

  const days: string[] = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    days.push(toDateString(d));
  }
  return days;
}

export function addDays(dateStr: string, count: number): string {
  const date = new Date(dateStr + "T00:00:00");
  date.setDate(date.getDate() + count);
  return toDateString(date);
}

export function getMonthDays(referenceDate: string): string[] {
  const date = new Date(referenceDate + "T00:00:00");
  const year = date.getFullYear();
  const month = date.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const startDayOfWeek = firstDay.getDay();
  const mondayOffset = startDayOfWeek === 0 ? -6 : 1 - startDayOfWeek;
  const gridStart = new Date(firstDay);
  gridStart.setDate(firstDay.getDate() + mondayOffset);

  const days: string[] = [];
  const current = new Date(gridStart);
  while (current <= lastDay || days.length % 7 !== 0) {
    days.push(toDateString(current));
    current.setDate(current.getDate() + 1);
    if (days.length > 42) break;
  }
  return days;
}

export function isSameMonth(dateStr: string, referenceDate: string): boolean {
  const d = new Date(dateStr + "T00:00:00");
  const r = new Date(referenceDate + "T00:00:00");
  return d.getMonth() === r.getMonth() && d.getFullYear() === r.getFullYear();
}

export function formatTimeRange(start: string, end: string): string {
  return `${start} - ${end}`;
}

export function formatDateShort(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  const currentYear = new Date().getFullYear();
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return y === currentYear ? `${d}/${m}` : `${d}/${m}/${y}`;
}
